import React, { useState, useEffect } from 'react';
import { RootState, AppDispatch } from 'src/store'
import axios from '../services/ApiService';
import { Card, CardContent, TextField, Button, Grid } from '@mui/material';
import { Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { updateOrganizationName } from '../store/apps/lookup';
import { unwrapResult } from '@reduxjs/toolkit';

const OrgNameChange = () => {
    const [orgName, setOrgName] = useState('');
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        fetchOrgName();
    }, []);

    const fetchOrgName = async () => {
        const response = await axios.get('invite/GetOrganizationName');
        setOrgName(response.data);
    };

    const updateOrgName = async () => {
        try {
            dispatch(updateOrganizationName(orgName));
        } catch (err) {
            console.error('Failed to update organization name: ', err);
        }
    };

    return (
        <Card>
            <CardContent>
                <Grid container spacing={1}>
                    <Grid item xs={4}>
                        <Grid container direction="column" spacing={2}>
                            <Grid item>
                                <Typography variant="h6">Update Organization Name</Typography>
                            </Grid>
                            <Grid item>
                                <TextField
                                    id="org_name"
                                    label="Organization Name"
                                    value={orgName}
                                    onChange={(e) => setOrgName(e.target.value)}
                                    sx={{ width: '100%' }}
                                />
                            </Grid>
                            <Grid item>
                                <Button variant="contained" onClick={updateOrgName}>
                                    Update
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default OrgNameChange;
